import React from 'react'
import { Link } from 'react-router-dom'
import spl from '../assets/portfolio/spl.png'
import  tv from '../assets/portfolio/tv.png'
import apartech from '../assets/portfolio/apartech.png'
import mshop from '../assets/portfolio/mshop.png'
import {Fade} from 'react-reveal'
import '../App.css';

const ProjectGrid = () => {
  return (
  <section className='bg-black lg-w-full'>
  <div className="title lg:flex lg:justify-center p-10 ">
    <div className='text lg:mt-5 lg:ml- sm:w-12/12'>
      <Fade>
      <h1 className='text-white font-bold text-2xl md:text-center lg:text-3xl text-start'>FEATURED PROJECTS</h1>
      <p className='text-white text-center'>Take a look at some of my recent projects below.</p>
      </Fade>
    </div>
    <button className='bg-orange-default text-white p-2 m-7 font-bold rounded mb-5 lg:ml-80'>
      <Link to='/projects'>View all</Link>
    </button>
  </div>
  <div className="cards p-2 pb-12 grid md:grid-cols-2 gap-y-10 pt-2">
    <div className="card bg-grey-default w-full md:w-8/12 h-25 mx-auto md:ml-32 md:mr-auto lg:ml-48">
      <h2 className='text-white font-bold text-xl text-center mt-5 md:mt-5'>Frontend design</h2>
      <div className="img w-10/12 ml-10 mt-10">
        <img src={apartech} alt="" />
      </div>
      <div className="project-text text-start p-2 ml-8">
        <h2 className='text-orange-default font-bold text-xl'>Apartech</h2>
        <p className='text-white font-medium'>Real Estate Management</p>
      </div>
    </div>
    <div className="card bg-grey-default w-full md:w-8/12 h-25 mx-auto md:ml-4 md:mr-auto">
      <h2 className='text-white font-bold text-xl text-center mt-5 md:mt-5'>UI/UX design</h2>
      <div className="img w-9/12 ml-12 mt-10">
        <img src={spl} alt="" />
      </div>
      <div className="project-text text-start p-2 ml-8">
        <h2 className='text-orange-default font-bold text-xl'>Splendid poetry</h2>
        <p className='text-white font-medium'>Poets and poem lover hub</p>
      </div>
    </div>
    <div className="card bg-grey-default w-full md:w-8/12 h-25 mx-auto md:ml-32 md:mr-auto lg:ml-48">
      <h2 className='text-white font-bold text-xl text-center mt-5 md:mt-5'>Fullstack app</h2>
      <div className="img w-11/12 ml-5 mt-12">
        <img src={tv} alt="" />
      </div>
      <div className="project-text text-start p-2 ml-8">
        <h2 className='text-orange-default font-bold text-xl'>Trip Vista</h2>
        <p className='text-white font-medium'>Tour management site</p>
      </div>
    </div>
    <div className="card bg-grey-default w-full md:w-8/12 h-25 mx-auto md:ml-4 md:mr-auto">
      <h2 className='text-white font-bold text-xl text-center mt-5 md:mt-5'>Frontend design</h2>
      <div className="img w-11/12 ml-5 mt-12">
        <img src={mshop} alt="" />
      </div>
      <div className="project-text text-start p-2 ml-8">
        <h2 className='text-orange-default font-bold text-xl'>M-shop</h2>
        <p className='text-white font-medium'>Watch shop</p>
      </div>
    </div>
  </div>
</section>

  
  )
}

export default ProjectGrid


